// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"496":"campaigns","528":"reports","594":"about","854":"widgets"}[chunkId] || chunkId) + "." + {"496":"9b90e8bb","512":"ef4c3dbc","528":"8c6be6aa","594":"37bdd2e3","854":"79d5fe1c"}[chunkId] + ".css";
};